const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    Liquidationvalue: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {

        case 'LIQUIDATIONVALUE_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                Liquidationvalue: action.payload
        };

        case 'LIQUIDATIONVALUE_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                Liquidationvalue: action.payload,
            };
        case 'SET_CURRENT_LIQUIDATIONVALUE':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                Liquidationvalue: action.payload
            };

        case 'LIQUIDATIONVALUE_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}